module.exports = __webpack_public_path__ + "img/newf.f1886719.jpg";